export default "__VITE_ASSET__ab6389f1__"